var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenu02Outlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 20H3.5C2.39543 20 1.5 19.1046 1.5 18V6C1.5 4.89543 2.39543 4 3.5 4H9C10.2267 4 11.3158 4.58901 12 5.49963C12.6842 4.58901 13.7733 4 15 4H20.5C21.6046 4 22.5 4.89543 22.5 6V18C22.5 19.1046 21.6046 20 20.5 20H15C14.1088 20 13.3386 20.5181 12.9743 21.2696C12.7846 21.6608 12.4347 22 12 22C11.5653 22 11.2154 21.6608 11.0257 21.2696C10.6614 20.5181 9.8912 20 9 20ZM3 6C3 5.72386 3.22386 5.5 3.5 5.5H9C10.2426 5.5 11.25 6.50736 11.25 7.75V19.2497C10.6233 18.779 9.84421 18.5 9 18.5H3.5C3.22386 18.5 3 18.2761 3 18V6ZM15 5.5C13.7574 5.5 12.75 6.50736 12.75 7.75V19.2497C13.3767 18.779 14.1558 18.5 15 18.5H20.5C20.7761 18.5 21 18.2761 21 18V6C21 5.72386 20.7761 5.5 20.5 5.5H15Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu02Outlined);
export default __webpack_public_path__ + "static/media/icon_menu02_outlined.d5b63c8da1b46aff4fe1346653371e38.svg";
export { ForwardRef as ReactComponent };